const Loader = () => {
  return (
    <div className="loaderWrapper">
      <div className="loader">
        <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}

export default Loader